import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import StateOptions from "utils/StateOptions";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding"

export default function CompanyLegalInformation(props) {
  const route = useContext(RouterContext)

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem(
      "routerHistory",
      JSON.stringify([...route.get])
    );
  }, [route.get]);
  let companyLogo = require("images/onboarding/company-logo.png");
  companyLogo = <img className="pt-4" src={`/datapulse${companyLogo}`} />;
  props.pageLocator();

  const [validated, setValidated] = useState(false);

  useEffect(() => {
    const form = document.getElementById("onboarding-form");
    if (form.checkValidity() === false) {
      setValidated(false);
    } else {
      setValidated(true);
    }
  });

  return (
    <>
      <Row className="pb-3 text-center justify-content-center">
        <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
        <Col>
          <p className="pb-3 f28 visby-bold primary ">Company Legal Information</p>
        </Col>
      </Row>
      <Row className="pb-3 justify-content-center">
        <Col md={7}>
          <p className=" f16 nunito-regular primary">
            Please add the company's information as it is known legally. It is important that this information is 100% accurate, so please double-check your
            spelling and grammar before continuing.
          </p>
        </Col>
      </Row>

      <Row className="pb-3 justify-content-center text-center ">
        <Col>
          <p className="f14 light-primary visby-bold">Legal Company Name:</p>
        </Col>
      </Row>
      <Row className="pb-3 justify-content-center">
        <Col md={10} lg={7} xl={6}>
          <Form.Control
            size="md"
            name="legal_company_name"
            className="pb-2 tableSearch mb-2 "
            placeholder=""
            required
            type="text"
            defaultValue={props.legalInfo[0]}
            onChange={(e) => props.legalChange(e, 0)}
          />
        </Col>
      </Row>
      <Row className="pb-3 justify-content-center text-center">
        <Col md={10} lg={7} xl={6}>
          <p className="f14 light-primary visby-bold">Legal Company Address</p>
        </Col>
      </Row>
      <Row className="pb-1 justify-content-center">
        <Col md={10} lg={7} xl={6}>
          <p className="f14 pl-2 light-primary nunito-regular text-left">Street Address</p>
        </Col>
      </Row>
      <Row className="pb-3 justify-content-center">
        <Col md={10} lg={7} xl={6}>
          <Form.Control
            size="md"
            name="street_address"
            className="tableSearch mb-2"
            defaultValue={props.legalInfo[1]}
            onChange={(e) => props.legalChange(e, 1)}
            required
            type="text"
          />
        </Col>
      </Row>
      <Row className="pb-1 justify-content-center">
        <Col md={10} lg={7} xl={6}>
          <p className="f14 pl-2 light-primary nunito-regular text-left">Unit, building, or apt #</p>
        </Col>
      </Row>
      <Row className="pb-3 justify-content-center">
        <Col md={10} lg={7} xl={6}>
          <Form.Control size="md" className=" mb-2" defaultValue={props.legalInfo[2]} name="unit_building_number" onChange={(e) => props.legalChange(e, 2)} />
        </Col>
      </Row>
      <Row className="pb-3 justify-content-center">
        <Col className="trim-o" md={10} lg={7} xl={6}>
          <Row>
            <Col className="" xs={12} md={5} >
              <Form.Group>
                <Form.Label className="f14 pl-2 light-primary nunito-regular text-left">City</Form.Label>
                <Form.Control
                  size="md"
                  name="city"
                  defaultValue={props.legalInfo[3]}
                  onChange={(e) => props.legalChange(e, 3)} className="tableSearch mb-2  "
                  required
                  type="text"
                />
              </Form.Group>
            </Col>
            <Col className="" xs={12} md={4} >
              <Form.Group>
                <Form.Label className="f14 pl-2 light-primary nunito-regular text-left">State/Province</Form.Label>
                <Form.Control
                  size="md"
                  name="state_province"
                  placeholder="State or Province"
                  defaultValue={props.legalInfo[4] ? props.legalInfo[4] : ""}
                  onChange={(e) => props.legalChange(e, 4)}
                  className="tableSearch mb-2 ">
                </Form.Control>
              </Form.Group>
            </Col>
            <Col className="" xs={12} md={3} >
              <Form.Group>
                <Form.Label className="f14 pl-2 light-primary nunito-regular text-left">Zip</Form.Label>
                <Form.Control
                  size="md"
                  name="postal_code"
                  defaultValue={props.legalInfo[5]}
                  onChange={(e) => props.legalChange(e, 5)}
                  className="tableSearch mb-2"
                  required
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="mt-3 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton
              btnText={`Skip for now`}
              nextPage={nextPage.url}
            />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
